import {useLayoutEffect} from 'react';

import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {isPubBeersArray, isRegularBeersArray} from 'typescript/guards/BeersGuards';
import {Beer} from 'typescript/models/Beer';
import {PubBeer} from 'typescript/models/PubBeer';

import {setTotalPagesAC} from '../slice';
import {beerManagerModes} from '../typescript';
import './Table.scss';
import AddBeersTable from './Tables/AddBeersTable/AddBeersTable';
import ListBeersTable from './Tables/ListBeersTable/ListBeersTable';
import ManageBeersTable from './Tables/ManageBeersTable/ManageBeersTable';

interface IProps {
  beersList: Beer[] | PubBeer[];
}

const Table = ({beersList}: IProps) => {
  const {mode} = useGlobalState((state) => state.beersManager);
  const dispatch = useSetGlobalState();

  const returnPubBeerArray = () => (isPubBeersArray(beersList) ? beersList : []);

  useLayoutEffect(() => {
    dispatch(setTotalPagesAC(1));
  }, [dispatch]);

  return (
    <>
      {mode === beerManagerModes.listBeers && <ListBeersTable beersList={returnPubBeerArray()} />}
      {mode === beerManagerModes.addBeers && (
        <AddBeersTable beersList={isRegularBeersArray(beersList) ? beersList : []} />
      )}
      {mode === beerManagerModes.manageBeers && <ManageBeersTable beersList={returnPubBeerArray()} />}
    </>
  );
};

export default Table;
